import type { InferOutput } from "valibot";

export const customerDetailsSchema = v.object({
  prefix: v.union([v.literal("billing"), v.literal("shipping")]),
  first_name: v.string(),
  last_name: v.string(),
  company: v.optional(v.string()),
  phone: v.string(),
  email: v.string(),
  address_1: v.string(),
  address_2: v.optional(v.string()),
  city: v.string(),
  state: v.string(),
  postcode: v.string(),
  country: v.string(),
});
export type CustomerDetails = InferOutput<typeof customerDetailsSchema>;

// Customer
export const customerSchema = v.object({
  billing: v.object({ ...customerDetailsSchema.entries, prefix: v.literal("billing") }),
  shipping: v.object({ ...customerDetailsSchema.entries, prefix: v.literal("shipping") }),
});
export type Customer = InferOutput<typeof customerSchema>;

// 'update_customer_details' input
export const updateCustomerDetailsSchema = v.object({
  customer_details: customerDetailsSchema,
});
export type UpdateCustomerDetails = InferOutput<typeof updateCustomerDetailsSchema>;
